// todo all commented code will be used in the next phase
import React, { useEffect, useMemo, useState } from "react";
import { observer } from "mobx-react";
import { useHistory } from "react-router-dom";
import { toJS } from "mobx";
// import { Plus } from "@styled-icons/boxicons-regular";
import { Close } from "@styled-icons/material/Close";

import { useTranslation } from "b2c/hooks/useTranslation";
import Content from "../Content";
import Steps from "../Steps";
import Dropdown from "../Dropdown";

// LocationItem,
import { SearchWrapper, Label, LocationsFlex, LocationItemActive } from "./styled";
import Navigation from "../Navigation";
import useStore from "../../../../contexts/store";

const JobLocations = ({ buildPath }) => {
  const [searchValue, setSearchValue] = useState("");
  const [locationValue, setLocationValue] = useState({});
  const [selectedLocations, setSelectedLocations] = useState([]);
  const { getGlobalLocations, globalLocations, clearGlobalLocations } = useStore("Onboarding");

  const history = useHistory();
  const { t } = useTranslation();

  const handleUnSelect = location => {
    const newLocations = selectedLocations.filter(item => item.value !== location.value);
    setSelectedLocations(newLocations);
  };

  const handleSearch = search => {
    setSearchValue(search);
  };

  const handleSetLocationValue = location => {
    if (location) {
      const findLocation = selectedLocations.find(item => item.id === location.value);

      setLocationValue({});
      setSearchValue("");

      if (!findLocation?.value) {
        setSelectedLocations(prev => [...prev, location]);
      }
    }
  };

  const handleSubmit = () => {
    const prevOnboardingForm = JSON.parse(sessionStorage.getItem("onboardingFlow"));

    const onboardingFlow = {
      ...prevOnboardingForm,
      preferredLocations: selectedLocations
    };

    sessionStorage.setItem("onboardingFlow", JSON.stringify(onboardingFlow));
    history.push(buildPath("/onboarding/job-titles"));
  };

  useEffect(() => {
    const onboardingFlow = JSON.parse(sessionStorage.getItem("onboardingFlow"));

    const isSelectLocation = onboardingFlow.preferredLocations && !selectedLocations.length;

    if (isSelectLocation) {
      setSelectedLocations(onboardingFlow.preferredLocations);
    }

    return () => {
      clearGlobalLocations();
    };
  }, []);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchValue.length >= 2) {
        getGlobalLocations(searchValue);
      }
    }, 800);

    return () => {
      clearTimeout(delayDebounceFn);
    };
  }, [searchValue]);

  const commonLocationsList = useMemo(() => {
    const selectedLocationsIds = new Set(selectedLocations.map(item => item.value));

    return toJS(globalLocations).filter(item => !selectedLocationsIds.has(item.id));
  }, [toJS(globalLocations)]);

  return (
    <div data-cy="job-locations">
      <Steps width="120px" />

      <Content title={t("onboarding.job_locations.title")} description={t("onboarding.job_locations.description")}>
        <SearchWrapper>
          <Dropdown
            handleSearch={handleSearch}
            searchValue={searchValue}
            handleSetLocationValue={handleSetLocationValue}
            locationValue={locationValue?.label ? locationValue : ""}
            options={commonLocationsList.map(item => ({ value: item.id, label: item.name, type: item.type }))}
          />
        </SearchWrapper>
        {/*
        <Label>{t("onboarding.job_locations.popular_locations")}</Label>
        <LocationsFlex>
          {popularLocationsList.map(item => (
            <LocationItem key={item.name} onClick={() => handleSelectLocation(item)}>
              {item.name} <Plus />{" "}
            </LocationItem>
          ))}
        </LocationsFlex>
        */}

        {selectedLocations.length > 0 ? (
          <>
            <Label>{t("onboarding.job_locations.selected_locations")}</Label>
            <LocationsFlex>
              {selectedLocations.map(item => (
                <LocationItemActive key={item?.label} onClick={() => handleUnSelect(item)}>
                  {item.label} <Close />{" "}
                </LocationItemActive>
              ))}
            </LocationsFlex>
          </>
        ) : null}
      </Content>

      <Navigation
        handleSubmit={handleSubmit}
        backUrl={buildPath("/onboarding/country")}
        isDisabled={!selectedLocations.length}
      />
    </div>
  );
};

export default observer(JobLocations);
